<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat class="card-header">
        <v-btn icon exact :to="{name: 'sites'}"><v-icon>clear</v-icon></v-btn>
        <span class="title">Edit Site</span>
        <v-spacer></v-spacer>
        <v-btn @click="showDeleteDialog = true" v-if="canDelete" depressed dark color="error" class="mx-2">Delete</v-btn>
        <v-btn @click="saveItem" depressed dark color="success">Save</v-btn>
      </v-toolbar>
      <v-container grid-list-sm>
        <v-layout row wrap>
          <v-flex xs12 sm4>
            <v-text-field
            v-model="item.name"
            label="Name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
            v-model="item.nameDisplay"
            label="Display Name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-switch
            label="Public"
            v-model="item.public">
            </v-switch>
          </v-flex>
          <v-flex xs12 sm4>
            <v-select
            v-model="item.plan"
            :disabled="!superAdmin"
            :items="billingPlans"
            item-text="name"
            return-object
            label="Plan"
            @change="updatePlan"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
            :value="formatDateTime(item.timeModified)"
            disabled
            label="Time Updated"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
            :value="formatDateTime(item.timeCreated)"
            disabled
            label="Time Created"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
            v-model="item.addressLine1"
            label="Address Line 1"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
            v-model="item.addressLine2"
            label="Address Line 2"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
            v-model="item.addressCity"
            label="Address City"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
            v-model="item.addressState"
            label="Address State"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
            v-model="item.addressZip"
            label="Address Zip"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
            @click:prepend="openMap"
            v-model="item.addressGeo.coordinates"
            label="Address Coordinates"
            :prepend-icon="canMap"
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-dialog v-model="showDeleteDialog" max-width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Delete Site</v-card-title>
        <v-card-text class="pt-4">
          Are you sure you want to delete this site?  <b>This action cannot be undone.</b>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="deleteItem">I'm sure</v-btn>
          <v-btn text @click="showDeleteDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'

export default {
  data () {
    return {
      billingPlans: [],
      item: {
        addressGeo: {}
      },
      loading: false,
      showDeleteDialog: false
    }
  },

  created () {
    this.getItem()
    ApiRequests.billingPlanQuery().then(r => {
      this.billingPlans = r.data
    })
  },

  computed: {
    ...mapGetters([
      'getUser',
      'selectedOrganization'
    ]),

    isNew: function () {
      if (this.$route.params.id === 'new') {
        return true
      }
      return false
    },

    canMap: function () {
      if (this.item.addressGeo.coordinates) {
        if (this.item.addressGeo.coordinates.length > 1) {
          return 'gps_fixed'
        }
      }
      return ''
    },

    canDelete: function () {
      return this.superAdmin && !this.isNew
    },

    superAdmin: function () {
      return this.getUser.memberships.superAdmin
    }
  },

  methods: {
    exit: function () {
      this.$router.push({ name: 'sites' })
    },

    deleteItem: function () {
      this.showDeleteDialog = false
      ApiRequests.siteDelete(this.$route.params.id).then(r => {
        this.exit()
      })
    },

    getItem: function () {
      if (this.isNew) return

      this.loading = true
      ApiRequests.siteGet(this.$route.params.id).then(r => {
        this.item = r.data
        this.loading = false
      })
    },

    openMap: function () {
      var coords = this.item.addressGeo.coordinates[1] + ',' + this.item.addressGeo.coordinates[0]
      window.open('https://www.google.com/maps/search/?api=1&query=' + coords)
    },

    saveItem: function () {
      this.loading = true

      if (this.isNew) {
        this.item.organization = this.selectedOrganization._id
        ApiRequests.siteCreate(this.item).then(r => {
          this.item = r.data
          this.loading = false
          this.exit()
        })
      } else {
        ApiRequests.siteSave(this.item).then(r => {
          this.item = r.data
          this.loading = false
          this.exit()
        })
      }
    },

    updatePlan: function () {
      if (!this.isNew) {
        ApiRequests.sitePlanPut(this.item._id, this.item).then(r => {
          this.item = r.data
        })
      }
    }
  }
}
</script>
